import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "container", 
    "text"
  ];
  
  show({ detail: { text } }) {
    const self = this;

    self.textTarget.textContent = text;
    self.containerTarget.classList.remove("hidden");

    setTimeout(function() {
      self.containerTarget.style.opacity = 1;
    }, 10);
  }

  hide() {
    const self = this;

    self.containerTarget.style.opacity = 0;

    setTimeout(function() {
      self.containerTarget.classList.add("hidden");
    }, 150);
  }

  updateText({ detail: { text } }) {
    this.textTarget.textContent = text;
  }
}
